export const citySelected = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'city_selected'
    })
}

export const deviceSelected = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'device_selected',
    })
}

export const modelSelected = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'model_selected',
    })
}

export const issueSelected = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'issue_selected',
    })
}

export const requestSubmitted = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'request_submitted',
    })
}

export const otpRequested = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'otp_requested',
    })
}

export const thankyouPage = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'thankyou_page',
    })
}

export const phoneNumber = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'phone_number',
    })
}

export const whatsapp = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'whatsapp',
    })
}